import { render, staticRenderFns } from "./PublicAssessment.vue?vue&type=template&id=5a3069ac&scoped=true"
import script from "./PublicAssessment.vue?vue&type=script&lang=js"
export * from "./PublicAssessment.vue?vue&type=script&lang=js"
import style0 from "./PublicAssessment.vue?vue&type=style&index=0&id=5a3069ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3069ac",
  null
  
)

export default component.exports